import { flushSync } from 'react-dom';

/**
 * Commit a state update before the browser paints the frame it arrived in.
 *
 * For a size read from a ResizeObserver: its callbacks run after layout and before paint, and a
 * plain update there renders in a later task, so whatever it lays out paints a frame behind the
 * box that changed size — the content slides with the box's edge, then resizes a frame later.
 */
export function commitBeforePaint(update: () => void): void {
    // flushSync throws if something upstream is already rendering; the plain update is one frame
    // late but correct, so degrade rather than drop.
    try {
        flushSync(update);
    } catch {
        update();
    }
}
